/*
 * Ryan O'Dowd
 * 2024-01-22
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({colors, globalScale, fonts}) => {
  return {
    smallCell: {
      display: 'flex',
      flexShrink: 1,
      justifyContent: 'flex-end',
    },
    errorTextWrapper: {
      paddingTop: 32,
    },
    errorText: {
      color: colors.primaryExtraLight,
      margin: 16,
      fontSize: globalScale * 20,
      textAlign: 'center',
    },
    bold: {
      fontFamily: fonts.primaryBold,
    },
    classroomName: {
      fontSize: globalScale * 28,
      fontFamily: fonts.secondaryBold,
      color: colors.primaryExtraLight,
      width: 'fit-content',
    },
    schoolName: {
      fontSize: globalScale * 16,
      width: 'fit-content',
    },
    logoLink: {
      position: 'absolute',
      top: -24, // @TODO: dynamic
      right: 0,
    },
    logo: {
      maxWidth: 200,
      maxHeight: 80,
      right: 0,
    },
    titleRow: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    goalsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      minHeight: 250, // @TODO: dynamic...this is just to ensure that on most screens, this section extends to the bottom of the page
    },
    joinCode: {
      padding: 6,
      backgroundColor: colors.accent,
      color: colors.primaryExtraDark,
      borderRadius: 6,
      fontSize: 14, // @TODO: should multiply by globalScale...make sure this looks good
      fontWeight: 'bold', // @TODO: fontFamily: fonts.primaryBold,
    },
    dangerous: {
      color: colors.alert,
    },
  };
};

export default getStyles;
